import React from "react";
import Avatar from "./ui/Avatar";
import UserLink from "./UserLink";
import CapturedPieces from "./CapturedPieces";

// The name plate shown above and below the board
const PlayerStrip = ({user, color, fen, clock, isYou, tag}) => {
    const name = user?.username || (color === "w" ? "White" : "Black");
    const isGuest = user && user.isActualUser === false && !user.isLoggedIn;
    return (
        <div className="player-strip">
            <Avatar name={name} size={38} guest={isGuest}/>
            <div className="player-strip__info">
                <div className="player-strip__name">
                    <UserLink user={user || {username: name}}/>
                    {isYou && <span className="chip chip--leaf">You</span>}
                    {tag}
                </div>
                <CapturedPieces fen={fen} color={color}/>
            </div>
            {clock}
        </div>
    );
};

export default PlayerStrip;
